var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-navigation-drawer",
        {
          staticStyle: { width: "300px !important" },
          attrs: {
            app: "",
            temporary: true,
            clipped: _vm.desktop,
            floating: _vm.mobile,
            "enable-resize-watcher": ""
          },
          model: {
            value: _vm.drawer,
            callback: function($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer"
          }
        },
        [
          _c(
            "v-list",
            { staticClass: "pt-5 pb-0", attrs: { dense: "" } },
            [
              _vm.$isSupervisor() || _vm.$isSeller()
                ? _c("menu-options", {
                    attrs: {
                      title: "Nueva Afiliación",
                      name: "icon-ic-nueva-afiliacion-blanco"
                    },
                    on: { click: _vm.newAffiliationRouter }
                  })
                : _vm._e(),
              _vm.$isBoss() ||
              _vm.$isAdmin() ||
              _vm.$isSupervisor() ||
              _vm.$isSeller()
                ? _c("menu-options", {
                    attrs: { title: "Dashboard", name: "icon-ic-dashboard" },
                    on: { click: _vm.dashboardRouter }
                  })
                : _vm._e(),
              _vm.$isBoss() ||
              _vm.$isAdmin() ||
              _vm.$isSupervisor() ||
              _vm.$isAdminCollaborator()
                ? _c("menu-options", {
                    attrs: {
                      title: "Colaboradores",
                      name: "icon-ic-colaboradores"
                    },
                    on: { click: _vm.collaboratorsRouter }
                  })
                : _vm._e(),
              _vm.$isAdmin() || _vm.$isAdminCollaborator()
                ? _c("menu-options", {
                    attrs: { title: "Reportes", name: "icon-ic-dashboard" },
                    on: { click: _vm.reportsRouter }
                  })
                : _vm._e(),
              _vm.$isTariffManager()
                ? _c("menu-options", {
                    attrs: { title: "Tarifas", name: "icon-ic-perfil" },
                    on: { click: _vm.tariffRouter }
                  })
                : _vm._e(),
              _c("menu-options", {
                attrs: { title: "Perfil", name: "icon-ic-perfil" },
                on: { click: _vm.profileRouter }
              }),
              _c("menu-options", {
                attrs: {
                  title: "Previsualización de Comisiones",
                  name: "icon-detalle"
                },
                on: { click: _vm.commissionPreviewerRouter }
              }),
              _c("menu-options", {
                attrs: { title: "Cerrar sesión", name: "icon-ic-logout-plomo" },
                on: {
                  click: function($event) {
                    _vm.$refs.CloseSessionModal.showModal()
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-toolbar",
        {
          staticClass: "elevation-0",
          attrs: { app: "", fixed: "", height: "66px" }
        },
        [
          _c(
            "v-layout",
            [
              _c("img", {
                staticClass: "hidden__responsive mt-1 mr-3",
                attrs: {
                  src: require("assets/images/img_logo_niubiz_on_white.svg"),
                  width: "89px",
                  height: "30px"
                }
              }),
              _c(
                "span",
                { staticClass: "hidden__responsive pl-3 span-style" },
                [_vm._v("GESTOR DE "), _c("br"), _vm._v(" AFILIACIÓN")]
              ),
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isPublicPage,
                      expression: "!isPublicPage"
                    }
                  ],
                  staticClass: "ml-4 ml-3 v-list__icon-menu",
                  attrs: { flat: "", icon: "" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.drawer = !_vm.drawer
                    }
                  }
                },
                [_c("v-icon", [_vm._v("icon-ic-menu")])],
                1
              ),
              _c("v-toolbar-title", [
                _vm.$isTariffManager()
                  ? _c("div", { staticClass: "hidden__responsive" }, [
                      _vm._v("Tarifas")
                    ])
                  : _c("div", { staticClass: "hidden__responsive" }, [
                      _vm._v(_vm._s(_vm.toolbarTitle))
                    ]),
                _c("img", {
                  staticClass: "logo__responsive mt-3 mr-3",
                  attrs: {
                    src: require("assets/images/img_logo_niubiz_on_white.svg"),
                    width: "60px"
                  }
                })
              ]),
              _c("v-spacer"),
              _c("v-layout", { attrs: { "justify-end": "" } }, [
                _c(
                  "div",
                  { staticClass: "toolbar__userName text-xs-right" },
                  [
                    _vm.isSuperUser
                      ? [
                          _c("h3", { staticClass: "mt-2" }, [
                            _vm._v("Administrador")
                          ])
                        ]
                      : [
                          _c("h3", { staticClass: "mb-0 mt-2" }, [
                            _vm._v(_vm._s(_vm.user.firstName))
                          ]),
                          _c("span", [_vm._v(_vm._s(_vm.user.lastName))])
                        ]
                  ],
                  2
                )
              ]),
              _c(
                "v-btn",
                {
                  staticClass: "hidden__responsive",
                  attrs: { icon: "", flat: "" },
                  on: {
                    click: function($event) {
                      _vm.$refs.CloseSessionModal.showModal()
                    }
                  }
                },
                [
                  _c("v-icon", { staticStyle: { color: "#b4b9bf" } }, [
                    _vm._v("icon-ic-logout-plomo")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("close-session-modal", { ref: "CloseSessionModal" }),
      _c(
        "v-content",
        [
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "transition",
                { attrs: { name: "slide-x-transition" } },
                [_c("nuxt")],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39336072", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39336072","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/default.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-39336072","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/default.vue
// module chunks = 20